import { defineMessage } from 'react-intl';

export const UNIT_STATUS_All = -1;
export const UNIT_STATUS_NEWLY = 1;
export const UNIT_STATUS_WAITING = 2;
export const UNIT_STATUS_HAPPENED = 3;
export const UNIT_STATUS_NOT_HAPPENED = 4;

export const UNIT_STATUSES = [
  {
    label: defineMessage({ id: 'unit.status.all', defaultMessage: 'All' }),
    value: UNIT_STATUS_All,
    color: 'rgb(26, 28, 33)',
  },
  {
    label: defineMessage({ id: 'unit.status.new', defaultMessage: 'New' }),
    value: UNIT_STATUS_NEWLY,
    color: '#E2B100',
  },
  {
    label: defineMessage({
      id: 'unit.status.waiting',
      defaultMessage: 'Waiting',
    }),
    value: UNIT_STATUS_WAITING,
    color: '#058ED9',
  },
  {
    label: defineMessage({
      id: 'unit.status.happened',
      defaultMessage: 'Happened',
    }),
    value: UNIT_STATUS_HAPPENED,
    color: '#14B24C',
  },
  {
    label: defineMessage({
      id: 'unit.status.not_happened',
      defaultMessage: 'Not happened',
    }),
    value: UNIT_STATUS_NOT_HAPPENED,
    color: '#ED0000',
  },
];
